<div class="d-flex mb-3 justify-content-end">
  <app-refresh-button
    [state]="fetchingMainDashboardState"
    [date]="cachedAt"
    (buttonClick)="onClickRefreshCache()"
  ></app-refresh-button>
</div>
<app-welcome-card
  [result]="mainDashboard.retainedConsumers| toKValue"
  [loading$]="loadingMainDashboardSelector$ | async"
  [isForbidden]="forbidden"
  [firstName]="firstName"
  [lastName]="lastName"
></app-welcome-card>
<div class="col-xl-12">
  <ng-container>
    <!-- Views Card -->
    <div class="row d-flex justify-content-center">
      <!-- Consumer Card -->
      <div class="col-12 col-md-6 col-xl-4 col-sm-6 col-xxl-4">
        <app-card
          [title]="impressionsCard.title | translate"
          [value]="mainDashboard.views"
          [icon]="impressionsCard.icon"
          [class]="impressionsCard.class"
          [isLoading]="loadingMainDashboardSelector$ | async"
          [isForbidden]="forbidden"
        >
        </app-card>
      </div>
      <div class="col-12 col-md-6 col-xl-4 col-sm-6 col-xxl-4">
        <app-card
          [title]="uniqueConsumersCard.title | translate"
          [icon]="uniqueConsumersCard.icon"
          [value]="mainDashboard.uniqueConsumers"
          [class]="'eye'"
          [isLoading]="loadingMainDashboardSelector$ | async"
          [isForbidden]="forbidden"
          [infoTooltip]="'infoTooltip.uniqueConsumers' | translate"
        >
        </app-card>
      </div>
      <div class="col-12 col-md-6 col-xl-4 col-sm-6 col-xxl-4">
        <app-card
          [title]="reachCard.title | translate"
          [value]="mainDashboard.reach"
          [icon]="reachCard.icon"
          [class]="reachCard.class"
          [isLoading]="loadingMainDashboardSelector$ | async"
          [isForbidden]="forbidden"
          [infoTooltip]="'infoTooltip.reach' | translate"
        >
        </app-card>
      </div>
      <div class="col-12 col-md-6 col-xl-4 col-sm-6 col-xxl-4">
        <app-card
          [title]="locationsCard.title | translate"
          [value]="mainDashboard.locations"
          [icon]="locationsCard.icon"
          [class]="locationsCard.class"
          [isLoading]="loadingMainDashboardSelector$ | async"
          [isForbidden]="forbidden"
        >
        </app-card>
      </div>
      <div class="col-12 col-md-6 col-xl-4 col-sm-6 col-xxl-4">
        <app-card
          [title]="routersCard.title | translate"
          [value]="mainDashboard.routers"
          [icon]="routersCard.icon"
          [class]="routersCard.class"
          [isLoading]="loadingMainDashboardSelector$ | async"
          [isForbidden]="forbidden"
        >
        </app-card>
      </div>
      <div class="col-12 col-md-6 col-xl-4 col-sm-6 col-xxl-4">
        <app-card
          [title]="adsCard.title | translate"
          [value]="mainDashboard.advertisingCampaigns"
          [icon]="adsCard.icon"
          [class]="adsCard.class"
          [isLoading]="loadingMainDashboardSelector$ | async"
          [isForbidden]="forbidden"
        >
        </app-card>
      </div>
    </div>
    <app-help [link]="bookMeeting" [type]="'lp'"></app-help>
  </ng-container>
  <div class="card rounded">
    <app-top-franchised></app-top-franchised>
  </div>
  <app-audience
    [inputAudience$]="inputAudience"
    [isPremium]="true"
    [startDate] = "startDate"
    [endDate] = "today"
  ></app-audience>
  <app-latest-advertising-campaigns></app-latest-advertising-campaigns>
</div>
